var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPressureDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-in-row",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#CFD8DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4022 12.8886L15.9999 8.49414L11.5977 12.8886C10.3844 14.1019 9.77771 15.7197 9.77771 17.2753C9.77771 18.8308 10.3844 20.4719 11.5977 21.6853C12.811 22.8986 14.4055 23.513 15.9999 23.513C17.5944 23.513 19.1888 22.8986 20.4022 21.6853C21.6155 20.4719 22.2222 18.8308 22.2222 17.2753C22.2222 15.7197 21.6155 14.1019 20.4022 12.8886ZM11.3333 17.5553C11.341 15.9997 11.8155 15.0119 12.7022 14.133L15.9999 10.7653L19.2977 14.1719C20.1844 15.043 20.6588 15.9997 20.6666 17.5553H11.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureDisabled);
export default __webpack_public_path__ + "static/media/pressure_disabled.140cb3d8.svg";
export { ForwardRef as ReactComponent };